import classNames from "classnames";
import "./Spinner.css";

export interface SpinnerProps {
  size?: number | string;
  color?: "multi" | "blue" | "mono";
  text?: string;
}

const Spinner = ({ size = 30, color = "multi" }: SpinnerProps) => (
  <div className="spinner" style={{ width: size }}>
    <svg viewBox="25 25 50 50">
      <circle
        className={classNames("spinner-path", {
          "color-blue": color === "blue",
          "color-mono": color === "mono",
        })}
        fill="none"
        cx="50"
        cy="50"
        r="20"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
    </svg>
  </div>
);

export default Spinner;
